import { render, staticRenderFns } from "./addNewPrompt.vue?vue&type=template&id=8e2e0316&scoped=true&"
import script from "./addNewPrompt.vue?vue&type=script&lang=js&"
export * from "./addNewPrompt.vue?vue&type=script&lang=js&"
import style0 from "./addNewPrompt.vue?vue&type=style&index=0&id=8e2e0316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2e0316",
  null
  
)

export default component.exports